import axios from "axios";
import API_V2_URL from "@/constants/API_V2_URL";

const AdministrativeUnitService = {
  all({ page, limit, q, status, all }) {
    return axios.get(
      `${API_V2_URL()}/system/administrative_units?page=${page}&status=${status}&limit=${limit}&q=${q}&all=${
        all ? "true" : "false"
      }`
    );
  },
  async employees(administrativeUnitId) {
    return (await axios.get(
      `${API_V2_URL()}/system/administrative_units/${administrativeUnitId}/employees`
    )).data;
  },
  async dispatches(administrativeUnitId) {
    return (await axios.get(
      `${API_V2_URL()}/system/administrative_units/${administrativeUnitId}/dispatches`
    )).data;
  },
  getAllAdministrativeUnits() {
    return axios.get(`${API_V2_URL()}/system/administrative_units?all=true`);
  },
  create(formData) {
    return axios.post(`${API_V2_URL()}/system/administrative_units`, formData);
  },
  update(formData, id) {
    return axios.put(
      `${API_V2_URL()}/system/administrative_units/${id}`,
      formData
    );
  }
};

export default AdministrativeUnitService;



// WEBPACK FOOTER //
// ./src/services/system/AdministrativeUnitService.js